export default function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
// module id = 377
// module chunks = 0